import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { BlockOutlined, CompareArrows, CopyAll, TaskAltOutlined } from '@material-ui/icons';
// material
import { useTheme } from '@material-ui/core/styles';
import {Menu,MenuItem,IconButton,ListItemIcon,ListItemText,Autocomplete,TextField,Grid,Stack,Button,Typography,Box,} from '@material-ui/core';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
import axios from 'axios';
import { FacilityTypes, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import ConfirmationPopup from '../../official-request/ConfirmationPopup';
import Modal from '../../blog/ProjectModel';
import MaterialTransferLoader from 'src/components/MaterialTransferLoader';

// ----------------------------------------------------------------------

ProductsMenu.propTypes = {
  onDelete: PropTypes.func,
  userName: PropTypes.string,
  id: PropTypes.number,
  status: PropTypes.number
};

export default function ProductsMenu({ onDelete, userName, id, status,setRefresh,selectedTab,timeAndMaterial, handleMove, page, rowsPerPage, row }) {
  const ref = useRef(null);
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false);
  const [openDeletePop,setOpenDeletePop] =useState(false)
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const duplicateThrottleRef = useRef(false);
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const [duplicateDisabled, setDuplicateDisabled] = useState(false);
  const [moveTarget, setMoveTarget] = useState(null);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [openTransferConfirm, setOpenTransferConfirm] = useState(false);
  const [openTransferLoader, setOpenTransferLoader] = useState(false);
  const [transferFacility, setTransferFacility] = useState(null);
  const [transferErrors, setTransferErrors] = useState({});
  const [transferSummary, setTransferSummary] = useState(null);
  const [transferLoading, setTransferLoading] = useState(false);
  const [openTransferDuplicatePop, setOpenTransferDuplicatePop] = useState(false);
  const [transferDuplicateMessage, setTransferDuplicateMessage] = useState('');

  const changeStatus = async (prodId, prodStatus) => {
    try {
      let id = prodId;
      let status = prodStatus;
      console.log("id-----", id, " status-----------", status)
      let response = await axios.post((`${REST_API_END_POINT}product/delete-product?id=${id}&status=${status}`),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
      // console.log("response-----------------", response.data);
      if (response.data.status === 1 || response.data.status === 2 || response.data.status === 4) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        navigate(PATH_DASHBOARD.products.main, { state: { data: true } });
      }
      else if (response.data.status === 0 || response.data.status === 3 || response.data.status === 5 || response.data.status === 500) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        navigate(PATH_DASHBOARD.products.main, { state: { data: true } });
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Error.........!", { variant: 'error' });
        navigate(PATH_DASHBOARD.products.main, { state: { data: true } });
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuItemClick = async (id, newStatus) => {
    setIsOpen(false)
    setOpenDeletePop(false);
    await changeStatus(id, newStatus);
    navigate(PATH_DASHBOARD.products.main);
  }

  const handleDuplicate = async () => {
    if (duplicateThrottleRef.current) return;
  
    // Lock future calls
    duplicateThrottleRef.current = true;
    setDuplicateDisabled(true);
    setIsOpen(false);
  
    try {
      const res = await axios.post(`${REST_API_END_POINT}product/duplicate`, { id });
  
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRefresh(true);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong!', { variant: 'error' });
    } finally {
      // Unlock after 1 second (throttle time)
      setTimeout(() => {
        duplicateThrottleRef.current = false;
        setDuplicateDisabled(false);
      }, 1000);
    }
  };

  const handleOpenTransferProduct = () => {
    setTransferFacility(null);
    setTransferErrors({});
    setTransferSummary(null);
    setOpenTransferModal(true);
    setIsOpen(false);
  };

  const handleSubmitTransfer = () => {
    if (!transferFacility?.id) {
      setTransferErrors({ transferFacility: 'Facility Required' });
      return;
    }
    setTransferErrors({});
    setOpenTransferConfirm(true);
  };

  const resetTransferState = () => {
    setOpenTransferModal(false);
    setOpenTransferConfirm(false);
    setOpenTransferLoader(false);
    setTransferFacility(null);
    setTransferErrors({});
    setTransferLoading(false);
  };

  const handleTransferProduct = async () => {
    setOpenTransferConfirm(false);
    setTransferLoading(true);
    setOpenTransferLoader(true);
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/transfer-product-to-facility`, {
        userId: userData?.user_id,
        productId: id,
        transferFacility,
        targetFacilityId: transferFacility?.id,
      });
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setTransferSummary(response.data.data || {});
        setOpenTransferModal(true);
      } else if (response.data.alreadyExists) {
        setTransferDuplicateMessage(
          response.data.message || `Product "${userName}" already exists in the selected facility.`
        );
        setOpenTransferDuplicatePop(true);
        resetTransferState();
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        resetTransferState();
      }
    } catch (error) {
      console.error('Error transferring product:', error);
      enqueueSnackbar('Error transferring product', { variant: 'error' });
      resetTransferState();
    } finally {
      setTransferLoading(false);
      setOpenTransferLoader(false);
    }
  };
  
  const handleEdit = async () => {
    if (status !== 1) {
      enqueueSnackbar('Inactive catalog. Please activate to edit.', { variant: 'warning' });
      setIsOpen(false);
      return;
    }

    setIsOpen(false);

    try {
      await axios.post(`${REST_API_END_POINT}product/mark-viewed`, { id });
    } catch (error) {
      console.error('Failed to mark catalog as read', error);
    }

    navigate(`${PATH_DASHBOARD.products.edit}?id=${id}/edit`, {
      state: {
        inhouse: selectedTab === 'in_house' ? true
          : selectedTab === 'in_stock_catalog' ? 4
          : selectedTab === 'client_owned_catalog' ? 5
          : selectedTab === 'split_catalog' ? 6
          : selectedTab === 'estimate_catalog' ? 7
            : false,
        timeAndMaterial: selectedTab === 'time_and_material',
        edit: id,
        isTrafficCatalog: selectedTab === 'traffic_catalog',
        selectedTab: selectedTab,
        listPage: page ?? 0,
        rowsPerPage: rowsPerPage ?? 25,
        scrollToProductId: row?.id ?? id
      }
    });
  };
  
  
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 'fit-width', maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >

        {
              selectedTab==="time_and_material"?
              <MenuItem
              disabled={explodedPermissions?.some(permission => ['Delete Catalog'].includes(permission)) ? false : true}
              onClick={()=>{setOpenDeletePop(true),setIsOpen(false)}}>
                  <ListItemIcon>
                  <Icon icon={trash2Outline} width={24} height={24} />
                  </ListItemIcon>
                  <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
                :
                <>
       

        <MenuItem
          disabled={explodedPermissions?.some(permission => ['Edit Catalog'].includes(permission)) ? false : true}
          // component={RouterLink}
          onClick={handleEdit}
          // to={`${PATH_DASHBOARD.products.edit}?id=${id}/edit`}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          disabled={duplicateDisabled || (explodedPermissions?.some(permission => ['Edit Catalog', 'Add Catalog'].includes(permission)) ? false : true)}
          onClick={handleDuplicate}
       >
         <ListItemIcon>
         <CopyAll icon={CopyAll} width={24} height={24} />
         </ListItemIcon>
         <ListItemText primary="Duplicate" primaryTypographyProps={{ variant: 'body2' }} />
       </MenuItem>
       { status === 1 ?<MenuItem onClick={handleOpenTransferProduct}>
          <ListItemIcon>
            <CompareArrows sx={{ width: 24, height: 24 }} />
          </ListItemIcon>
          <ListItemText primary="Transfer Product" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>:""}
        {status === 1 ? (
          <MenuItem
          disabled={explodedPermissions?.some(permission => ['Activate/Deactivate Catalog'].includes(permission)) ? false : true}
          onClick={() => handleMenuItemClick(id, 0)}
          >
            <ListItemIcon>
              <BlockOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Deactivate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ) : (
          <MenuItem
          disabled={explodedPermissions?.some(permission => ['Activate/Deactivate Catalog'].includes(permission)) ? false : true}
          onClick={() => handleMenuItemClick(id, 1)}
          >
            <ListItemIcon>
              <TaskAltOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Activate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        <MenuItem
        disabled={explodedPermissions?.some(permission => ['Delete Catalog'].includes(permission)) ? false : true}
        onClick={()=>{setOpenDeletePop(true),setIsOpen(false)}}>
            <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>

          {/* Move options - Only show if not time_and_material or inactive_catalogs */}
          {['in_house', 'in_stock_catalog', 'sub_contract', 'traffic_catalog', 'client_owned_catalog', 'estimate_catalog'].includes(selectedTab) && (
            <>

             {selectedTab !== 'in_house' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'in_house', name: 'Production Catalog' })}>
                  <ListItemIcon><span className="ic--outline-move-down" /></ListItemIcon>
                  <ListItemText primary="Move to Production Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}

              {selectedTab !== 'in_stock_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'in_stock_catalog', name: 'In Stock Catalog' })}>
                  <ListItemIcon><span className="ic--sharp-move-up" /></ListItemIcon>
                  <ListItemText primary="Move to In Stock Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'client_owned_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'client_owned_catalog', name: 'Client Owned Catalog' })}>
                  <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
                  <ListItemText primary="Move to Client Owned Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'traffic_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'traffic_catalog', name: 'Traffic Catalog' })}>
                  <ListItemIcon><span className="material-symbols--moved-location-rounded" /></ListItemIcon>
                  <ListItemText primary="Move to Traffic Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'sub_contract' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'sub_contract', name: 'Sub Contract' })}>
                  <ListItemIcon><span className="hugeicons--square-arrow-move-right-up" /></ListItemIcon>
                  <ListItemText primary="Move to Sub Contract" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}

              {selectedTab !== 'estimate_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'estimate_catalog', name: 'Estimate Catalog' })}>
                  <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
                  <ListItemText primary="Move to Estimate Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
            </>
          )}

          </>
        }
      </Menu>

    {/* Confirmation for deleting product  */}
    <ConfirmationPopup 
      open={openDeletePop}
      handleClose={()=>{setOpenDeletePop(false)}}
      message={`You want to delete ${userName} ! `}
      handleClick={()=>{handleMenuItemClick(id, 2)}}
    />

    <ConfirmationPopup
      open={!!moveTarget}
      handleClose={() => setMoveTarget(null)}
      message={`Are you sure you want to move "${userName}" to ${moveTarget?.name}?`}
      handleClick={() => {
        handleMove(moveTarget.id, moveTarget.target);
        setMoveTarget(null);
      }}
    />

    <ConfirmationPopup
      open={openTransferConfirm}
      handleClose={() => setOpenTransferConfirm(false)}
      message={`Transfer "${userName}" to ${transferFacility?.label || transferFacility?.name || 'selected facility'}? This will copy the product, formula, materials, and services to the target database.`}
      handleClick={handleTransferProduct}
    />

    <Modal
      modalTitle="Product Already Exists"
      open={openTransferDuplicatePop}
      handleClose={() => {
        setOpenTransferDuplicatePop(false);
        setTransferDuplicateMessage('');
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={10}>
          <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
              {transferDuplicateMessage || `Product "${userName}" already exists in the selected facility.`}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              No changes were made. This product will not be transferred again.
            </Typography>
            <Button
              variant="contained"
              onClick={() => {
                setOpenTransferDuplicatePop(false);
                setTransferDuplicateMessage('');
              }}
            >
              OK
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>

    <Modal
      modalTitle={transferSummary ? 'Transfer Complete' : 'Transfer Product'}
      open={openTransferModal}
      handleClose={() => {
        resetTransferState();
        setTransferSummary(null);
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={8}>
          {transferSummary ? (
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary">
                Product transferred to {transferSummary.targetFacilityName || transferSummary.installationName || 'target facility'}.
              </Typography>
              <Box sx={{ bgcolor: 'background.neutral', borderRadius: 1, p: 2 }}>
                <Typography variant="body2"><strong>Target product ID:</strong> {transferSummary.transferredProductId}</Typography>
                <Typography variant="body2"><strong>Materials:</strong> {transferSummary.materialCount}</Typography>
                <Typography variant="body2"><strong>Services:</strong> {transferSummary.serviceCount}</Typography>
                <Typography variant="body2"><strong>Formula rows:</strong> {transferSummary.formulaCount}</Typography>
                <Typography variant="body2"><strong>Reused records:</strong> {transferSummary.reusedCount}</Typography>
                <Typography variant="body2"><strong>Created records:</strong> {transferSummary.createdCount}</Typography>
                {/* {Array.isArray(transferSummary.messages) && transferSummary.messages.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    {transferSummary.messages.map((msg, idx) => (
                      <Typography key={idx} variant="body2" color="text.secondary">• {msg}</Typography>
                    ))}
                  </Box>
                )} */}
              </Box>
              <Button variant="contained" onClick={() => { resetTransferState(); setTransferSummary(null); }}>
                Close
              </Button>
            </Stack>
          ) : (
            <Stack spacing={3}>
              <Typography variant="body2" color="text.secondary">
                Select the target facility. The product definition, formula, materials, and services will be transferred with new ID mappings.
              </Typography>
              <Autocomplete
                fullWidth
                options={FacilityTypes?.filter((item) => !item.default) || []}
                value={transferFacility}
                onChange={(event, newValue) => {
                  setTransferFacility(newValue);
                  setTransferErrors((prev) => ({ ...prev, transferFacility: '' }));
                }}
                getOptionLabel={(option) => option?.label || option?.name || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    error={!!transferErrors.transferFacility}
                    helperText={transferErrors.transferFacility}
                    label="Select facility"
                  />
                )}
              />
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button variant="outlined" onClick={() => resetTransferState()}>
                  Cancel
                </Button>
                <Button variant="contained" disabled={transferLoading} onClick={handleSubmitTransfer}>
                  Transfer Product
                </Button>
              </Stack>
            </Stack>
          )}
        </Grid>
      </Grid>
    </Modal>

    <Modal
      modalTitle="Transfer Product"
      open={openTransferLoader}
      handleClose={() => {}}
    >
      <MaterialTransferLoader message={`Transferring ${userName} to ${transferFacility?.label || transferFacility?.name || 'facility'}...`} />
    </Modal>

    </>
  );
}
